/** Shared "glass" primary-button style — solid button/glass/accent/bg with a faint white sheen
 *  layered on top, plus its accent-colored glow shadow. Bind via `[style.background]` (not
 *  `[style.background-image]` — the trailing `var(--button-glass-accent-bg)` is a
 *  background-color, which background-image can't parse and would silently drop the whole
 *  declaration). Reads the same `--button-glass-accent-bg`/`--elevation-cta-glow` custom
 *  properties defined in design-system-2.1-tokens.css, rather than hardcoding the light-theme
 *  hex/rgba values, so both light and dark theme overrides (`.theme_dark` block) apply
 *  automatically. */
export const GLASS_BUTTON_BG =
  "linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 60%), var(--button-glass-accent-bg)";
export const GLASS_BUTTON_SHADOW = "var(--elevation-cta-glow)";
